export const expectedJwtAudience = 'haridusportaal.ee';
export const expectedJwtType = 'API';
export const expectedJwtIssuer = 'ehis.ee';